// extracted by mini-css-extract-plugin
export default {"subheaderTwo":"subheaderTwo_subheaderTwo__rXSZ1","username":"subheaderTwo_username__LhXWQ","button":"subheaderTwo_button__QCedP","active":"subheaderTwo_active__PXaDa"};